const actions = {
  // 設定ボタン
  // 表示
  DISP_SETTING_BUTTON({ commit }) {
    commit('SET_SETTING_BUTTON_VISIBLE', {
      isSettingButtonVisible: true,
    })
  },
  // 非表示
  HIDE_SETTING_BUTTON({ commit }) {
    commit('SET_SETTING_BUTTON_VISIBLE', {
      isSettingButtonVisible: false,
    })
  },

  // アカウント設定ボタンの表示
  // 表示
  DISP_ACCOUNT_SETTING_BUTTON({ commit }) {
    commit('SET_ACCOUNT_SETTING_BUTTON_VISIBLE', {
      isAccountSettingButtonVisible: true,
    })
  },
  // 非表示
  HIDE_ACCOUNT_SETTING_BUTTON({ commit }) {
    commit('SET_ACCOUNT_SETTING_BUTTON_VISIBLE', {
      isAccountSettingButtonVisible: false,
    })
  },

  // 案件選択ボタンの表示
  // 表示
  DISP_IO_SELECT_BUTTON({ commit }) {
    commit('SET_IO_SELECT_BUTTON_VISIBLE', {
      isIOSelectButtonVisible: true,
    })
  },
  // 非表示
  HIDE_IO_SELECT_BUTTON({ commit }) {
    commit('SET_IO_SELECT_BUTTON_VISIBLE', {
      isIOSelectButtonVisible: false,
    })
  },

  // 広告主設定ボタン
  // 表示
  SET_ADV_SELECT_BUTTON({ commit }, { visible }) {
    commit('SET_ADV_SELECT_BUTTON_VISIBLE', {
      isAdvSelectButtonVisible: visible,
    })
  },

  //通知ボタン
  //表示
  DISP_NOTIFICATION_BUTTON({ commit }) {
    commit('SET_NOTIFICATION_BUTTON_VISIBLE', {
      isNotificationButtonVisible: true,
    })
  },
  // 非表示
  HIDE_NOTIFICATION_BUTTON({ commit }) {
    commit('SET_NOTIFICATION_BUTTON_VISIBLE', {
      isNotificationButtonVisible: false,
    })
  },
}

export default actions
